export default __webpack_public_path__ + "static/media/untiring-patients-overlay.df4c52b3.svg";